<template>
  <div class="event__up">
    <div class="event__up-title">
      <LKRoadmapsFeedAttentionDrop
        v-if="node.data.description"
        :description="node.data.description"
      />

      <div class="text-h6 mod--event">
        {{ node.data.name }}
      </div>
    </div>

    <div class="event__up-label">
      <div class="event__label-right">
        <LKRoadmapsFeedLabelDate
          :from="node.data.start_at"
          :to="node.data.end_at"
          :node="node"
          :disabled="!isAdresat || readonly"
          @input="$emit('change:date', node, $event, arguments[1])"
        />
        <span
          v-if="node.data.is_read === false"
          class="text-sm mod--status-direction"
          v-text="'Изменено'"
        />
      </div>

      <div class="event__label-left">
        <LKRoadmapsFeedLabelStatus
          v-if="isExpertButtonVisible"
          :status="node.data.expert_status"
          :needs-check="node.data.needs_check"
          is-expert
          :toggle="isPotencialExpert && !!node.data.end_at"
          class="mod--margin"
          @change="$emit('change:expert-status', node, $event, arguments[1])"
        />

        <IconEye
          v-if="isExpertActionVisible"
          :count="node.data.is_read === false ? '•' : null"
          class="cursor-pointer"
          style="margin-right: 15px; margin-left: 0;"
          @click.native="onGoToExpertise(node)"
        />

        <LKRoadmapsFeedLabelStatus
          :status="node.data.status"
          :needs-check="node.data.needs_check"
          is-adresat
          :toggle="isAdresat && !readonly && !statusless && !!node.data.end_at"
          class="mod--margin"
          @change="$emit('change:status', node, $event, arguments[1])"
        />

        <LKRoadmapsFeedLabelStatus
          :status="node.data.status"
          :needs-check="node.data.needs_check"
          is-curator
          :toggle="isCurator && !!node.data.end_at"
          @change="$emit('change:status', node, $event, arguments[1])"
        />

        <IconHistory
          :count="node.data.is_read === false ? '•' : null"
          class="cursor-pointer"
          @click.native="$emit('open-history', node)"
        />

        <IconChat
          :count="node.data.unread_comments_count"
          class="cursor-pointer"
          @click.native="$emit('open-dialog', node)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import IconEye from '@/components/lk/icons/LKIconEye.vue'
import IconChat from '@/components/lk/icons/LKIconChat.vue'
import IconHistory from '@/components/lk/icons/LKIconHistory.vue'
import LKRoadmapsFeedAttentionDrop from '../ui/LKRoadmapsFeedAttentionDrop.vue'
import LKRoadmapsFeedLabelStatus from '../ui/LKRoadmapsFeedLabelStatus.vue'
import LKRoadmapsFeedLabelDate from '../ui/LKRoadmapsFeedLabelDate.vue'

import { lkMapper } from '@/store/modules/lk'
import { LK_ROADMAPS_EXPERTS_ROUTES } from '@/views/LKRoadmapsExperts/utils'
import {
  RoadmapEventStatuses,
  RoadmapEventExpertStatuses,
} from '@/typings/api/RoadmapEvent'
import { lkRoadmapPermissions as Permissions } from '@/helpers/enums/permission-models'

export default {
  name: 'LKRoadmapsFeedCardEventUp',
  inject: ['isAdresat', 'isCurator', 'isCoordinator'],
  components: {
    IconEye,
    IconChat,
    IconHistory,
    LKRoadmapsFeedAttentionDrop,
    LKRoadmapsFeedLabelStatus,
    LKRoadmapsFeedLabelDate,
  },
  inheritAttrs: false,
  props: {
    node: {
      type: Object,
      required: true,
    },
    statusless: Boolean,
    readonly: Boolean,
  },
  data: () => ({
    RoadmapEventStatuses,
    RoadmapEventExpertStatuses,
  }),
  computed: {
    ...lkMapper.mapGetters(['profile']),
    isExpertButtonVisible() {
      const { data } = this.node
      return data.criterions_exist && (
        [RoadmapEventStatuses.done, RoadmapEventStatuses.confirmed].includes(
          data.status,
        ) || data.expert_status != null
      )
    },
    isExpertActionVisible() {
      return (
        this.isExpert
        && [
          RoadmapEventExpertStatuses.inProgress,
          RoadmapEventExpertStatuses.done,
        ].includes(this.node.data.expert_status)
      )
    },
    /**
     * Фактический эксперт - тот, кто уже работает с формой.
     */
    isExpert() {
      return this.node.data.expert_user_id === this.profile.id
    },
    /**
     * Эксперт, но он необязательно проверяет данную форму.
     */
    isPotencialExpert() {
      return (
        this.$access(Permissions.expert)
        && (this.isExpert || !this.node.data.expert_user_id)
      )
    },
  },
  methods: {
    onGoToExpertise(node) {
      if (this.node.data.expert_status === RoadmapEventExpertStatuses.done) {
        this.$router.push({
          name: LK_ROADMAPS_EXPERTS_ROUTES.LAYOUT_READONLY,
          params: {
            id: node.data.id,
          },
        })
      } else {
        this.$router.push({
          name: LK_ROADMAPS_EXPERTS_ROUTES.LAYOUT,
          query: {
            eventId: node.data.id,
          },
        })
      }
    },
  },
}
</script>
